import React from 'react'
import "./FlightDetails.css"

function FlightDetails({ label, data, border }) {
    return (
        <div className={!border ? 'flight_details' : 'no_border'}>
            <div className='flight_label'>{label}</div>
            <div className='flight_label'>{data}</div>
        </div>
    )
}

export default FlightDetails
